<app-card
  title="{{'admin.solution.template.step' | translate}} {{Index + 1}}: {{solutionSteps[Index].actionType.translationKey | translate}}"
  cardClass = "{{ cardIsActive ? '' : 'inactive' }}"
  [titleHasIcon]="cardIsActive"
  [titleIconActive] = "this.request.reply.replyItems[this.Index] && this.request.reply.replyItems[this.Index].isDone"
  *ngIf="cardIsActive"
>
  <div *ngIf="solutionSteps[Index]" [ngSwitch]="solutionSteps[Index].actionType.name">
    <app-reply-step-confirmation *ngSwitchCase="'confirmation'" [Index]="Index" [isActive]="cardIsActive"></app-reply-step-confirmation>
    <app-reply-step-email *ngSwitchCase="'email'" [Index]="Index" [isActive]="cardIsActive"></app-reply-step-email>
    <app-reply-step-text *ngSwitchCase="'text'" [Index]="Index" [isActive]="cardIsActive"></app-reply-step-text>
    <app-reply-step-form *ngSwitchCase="'form'" [Index]="Index" [isActive]="cardIsActive"></app-reply-step-form>
    <app-reply-step-packaging-label *ngSwitchCase="'packaging_label'" [Index]="Index" [isActive]="cardIsActive"></app-reply-step-packaging-label>
    <app-reply-step-invoice *ngSwitchCase="'invoice'" [Index]="Index" [isActive]="cardIsActive"></app-reply-step-invoice>
    <app-reply-step-reorder *ngSwitchCase="'re_order'" [Index]="Index" [isActive]="cardIsActive"></app-reply-step-reorder>
    <app-reply-step-change-status *ngSwitchCase="'change_status'" [Index]="Index" [isActive]="cardIsActive"></app-reply-step-change-status>
  </div>
</app-card>
